import { useAlert } from 'components/alert/AlertStack';
import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { FormAction } from 'components/form/FormAction';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { FormSection } from 'components/form/FormSection';
import { FormSelect } from 'components/form/FormSelect';
import { MutationForm } from 'components/form/graphql/MutationForm';
import { UpdateContactMutation } from 'graphql/Contact/mutations/UpdateContactMutation';
import { React } from 'libs/react';
import { useAccount } from 'components/account/AccountProvider';
import { useTranslation } from 'components/translation/TranslationProvider';
import { FormGoogleAutocompleteInput } from 'components/form/FormGoogleAutocompleteInput';
import { FormPhone } from 'components/form/FormPhone';
import './CreateContactPanel.scss';
/**
 * @component UpdateContactPanel
 * @since 1.0.0
 */
export function UpdateContactPanel(props) {
    var _a, _b, _c, _d, _e, _f;
    const { style, contact, isEndClient } = Object.assign({ style: 'normal' }, props);
    const alert = useAlert();
    const account = useAccount();
    const { customLabels, language } = useTranslation();
    const [locationId, setLocationId] = useState(((_a = contact.location) === null || _a === void 0 ? void 0 : _a.id) || null);
    const [location, setLocation] = useState(contact.location
        ? {
            civicNumber: contact.location.civicNumber || '',
            road: contact.location.road || '',
            apartment: contact.location.apartment || '',
            city: contact.location.city || '',
            province: contact.location.province || '',
            country: contact.location.country || '',
            postalcode: contact.location.postalcode || '',
            latitude: contact.location.latitude || 0,
            longitude: contact.location.longitude || 0
        }
        : null);
    /**
     * @function onProcess
     * @since 1.0.0
     * @hidden
     */
    function onProcess(values) {
        const { firstname, lastname, contactEmail, client, title, contactLanguage, contactPhone, extension } = values;
        const input = {
            id: contact.id,
            firstname,
            lastname,
            title,
            client,
            language: contactLanguage,
            location: locationId,
            locationValues: location,
            primary: contact.primary || true,
            manager: contact.manager || false
        };
        if (contactEmail !== undefined) {
            if (contactEmail) {
                input.emails = [
                    {
                        type: 'WORK',
                        email: contactEmail,
                        primary: true
                    }
                ];
            }
            else {
                input.emails = [];
            }
        }
        if (contactPhone !== undefined) {
            if (contactPhone) {
                input.phones = [
                    {
                        type: 'WORK',
                        phone: contactPhone,
                        extension: extension || '',
                        primary: true
                    }
                ];
            }
            else {
                input.phones = [];
            }
        }
        return {
            variables: {
                input
            }
        };
    }
    /**
     * @function onSuccess
     * @since 1.0.0
     * @hidden
     */
    function onSuccess(result) {
        var _a;
        alert.present({
            title: (React.createElement("p", null,
                React.createElement("strong", null, (_a = result === null || result === void 0 ? void 0 : result.updateContact) === null || _a === void 0 ? void 0 : _a.fullname),
                ' ',
                t('has been updated.')))
        });
        if (props.onDone) {
            props.onDone(result.updateContact);
        }
    }
    /**
     * @function onFailure
     * @since 1.0.0
     * @hidden
     */
    function onFailure(error) {
        alert.present({ error });
    }
    const className = classNames('create-contact-panel', 'create-contact-panel--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(MutationForm, { name: "contact-update-form", mutation: UpdateContactMutation, onProcess: onProcess, onSuccess: onSuccess, onFailure: onFailure, style: style },
            React.createElement(FormSection, { title: `${t('Edit')} ${isEndClient
                    ? customLabels['contact'][language]
                    : customLabels['representative'][language]}`, style: style },
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "firstname", label: t('First Name'), placeholder: t('Enter First Name'), defaultValue: contact.firstname, required: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "lastname", label: t('Last Name'), placeholder: t('Enter Last Name'), defaultValue: contact.lastname, required: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "title", label: t('Title'), placeholder: t('Enter Title'), defaultValue: contact.title, optional: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormSelect, { name: "contactLanguage", label: t('Language'), placeholder: t('Select Language'), options: account.languages.map((lang) => ({
                                value: lang.id,
                                label: lang.name
                            })), defaultValue: ((_b = contact.language) === null || _b === void 0 ? void 0 : _b.id) ||
                                ((_c = account.languages.find((lang) => lang.primary)) === null || _c === void 0 ? void 0 : _c.id), optional: true }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "email", name: "contactEmail", label: t('Email'), placeholder: t('Enter Email'), defaultValue: (_d = contact.primaryEmail) === null || _d === void 0 ? void 0 : _d.email }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormPhone, { name: "contactPhone", label: t('Phone'), placeholder: t('Enter Phone'), defaultValue: (_e = contact.primaryPhone) === null || _e === void 0 ? void 0 : _e.phone }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "extension", label: t('Extension'), placeholder: t('Enter Extension'), defaultValue: (_f = contact.primaryPhone) === null || _f === void 0 ? void 0 : _f.extension }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormGoogleAutocompleteInput, { name: "address", label: t('Address'), placeholder: t('Enter Address'), value: location
                                ? (location === null || location === void 0 ? void 0 : location.civicNumber) +
                                    ' ' +
                                    (location === null || location === void 0 ? void 0 : location.road) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.city) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.province) +
                                    ', ' +
                                    (location === null || location === void 0 ? void 0 : location.country)
                                : '', onLocationSelected: (location) => {
                                setLocation(location);
                                setLocationId(null);
                            } })))),
            React.createElement(FormAction, { align: "stretch" },
                props.onCancel && (React.createElement(Button, { style: "outline", label: t('Cancel'), onPress: props.onCancel })),
                React.createElement(Button, { style: "primary", label: `${t('Update')} ${isEndClient ? customLabels['contact'][language] : customLabels['representative'][language]}`, badge: "arrow-right", submit: true })))));
}
